import React from 'react'
import { Wrapper, BarStrip, ProgressBar, Modal } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setOpenNotificationModal } from '../_slices/AppSlice'

const NextActionField = ( record ) => {
    const dispatch = useDispatch()
    return (
      <div onClick={async () => {
        await dispatch( setOpenNotificationModal( { 
          flag: true,
          type: record.row.original.task
        } ) )
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

export default function AllNotification( { product } ) {
  const dispatch = useDispatch()
  const state = useSelector( state => { 
    return {
        displayModal: state.application.notifModal?.display,
        type: state.application.notifModal?.type,
    }
  })
  const NotificationColumns = React.useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Task",
      accessor: "task"
    },
    {
      Header: "Date Created",
      accessor: "date"
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: NextActionField
    },
    // {
    //   Header: "Action",
    //   accessor: "id",
    //   Cell: ActionField
    // }
  ] )
  
  const [ records, setRecords ] = React.useState( [] )
  const [ loading, setLoading ] = React.useState( true )

  React.useEffect( () => {
    if( loading ) {
        fetchNotifications()
    }
  },[ loading ])

  const fetchNotifications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itconotifications/${localStorage.getItem( "applicationId" )}` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            email_address: result.email_address || localStorage.getItem( "email" ),
            task: result.task,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            comment: result.comment,
            action: result.task === "Verified" && "Payment" 
        }
       } )

       //update the state
       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handlePayment = async () => {
    // alert( state.type )

    if( state.type?.toLowerCase() === "schedule_audit" ) {
      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: localStorage.getItem( "applicationId" ),
          progress: parseInt( localStorage.getItem( "applicationProgress") ) + 20 ,
          email_address: localStorage.getItem( "email" ),
          task: "Audit_Submitted",
          created_by: localStorage.getItem( "email" ),
          comment: "Audit has been submitted",
          stage: 5
        } )
        if( response.data ) {
          alert( response.data.message )
          await dispatch( setOpenNotificationModal( { 
            flag: false
          } ))
          return window.location.reload()
        }
      } catch (error) {
        
      }
    }

    if( state.type?.toLowerCase() === "verified" ) {
      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: localStorage.getItem( "applicationId" ),
          progress: parseInt( localStorage.getItem( "applicationProgress") ) + 20 ,
          email_address: localStorage.getItem( "email" ),
          task: "Paid",
          created_by: localStorage.getItem( "email" ),
          comment: "Payment has been made",
          stage: 4
        } )
        if( response.data ) {
          alert( response.data.message )
          await dispatch( setOpenNotificationModal( { 
            flag: false
          } ))
          return window.location.reload()
        }
      } catch (error) {
        
      }
    }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          {/* <BarStrip /> */}
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Your Notifications List for Application ID: ${localStorage.getItem( "applicationId" )}`}
            </div>
            <div className="flex w-full bg-white">
              <Table
                label="Notifications List"
                columns={NotificationColumns}
                data={records}
              />
            </div>
          </div>
        </div>
        <Modal
          title={"Action Details"}
          displayModal={state.displayModal} 
          handleDisplayModal={() => dispatch( setOpenNotificationModal( { flag: false } ) ) }
          handleFormSubmit={() => {}}>
            <button type="button" onClick={handlePayment}>{`Make Payment`}</button>
        </Modal>
    </Wrapper>
  )
}
